import React from 'react';
import type { Pagination } from '../types';
import './mobileAdminComponents.css';

export function PaginationControls({ pagination, onPageChange, disabled = false }: { pagination: Pagination; onPageChange: (page: number) => void; disabled?: boolean }) {
    const { page, totalPages, total, limit } = pagination;
    if (totalPages <= 1 && total <= limit) return null;
    return (
        <nav className="ma-pagination" aria-label="Pagination">
            <span>Page {page} of {Math.max(totalPages, 1)} · {total} results</span>
            <div>
                <button type="button" onClick={() => onPageChange(page - 1)} disabled={disabled || page <= 1}>Previous</button>
                <button type="button" onClick={() => onPageChange(page + 1)} disabled={disabled || page >= totalPages}>Next</button>
            </div>
        </nav>
    );
}
